import { useDrawer } from './useDrawer';

export const useDialog = useDrawer;
